import React from 'react';
import { LucideIcon } from 'lucide-react';
import MetricInfoPopover, { type MetricInfoDefinition } from '../ui/MetricInfoPopover';
import { opsStatCard } from '../operations/operationsUi';

type InsightsStatCardProps = {
  label: string;
  value: React.ReactNode;
  sub?: string;
  icon?: LucideIcon;
  accent?: string;
  loading?: boolean;
  info?: MetricInfoDefinition;
  className?: string;
};

const InsightsStatCard: React.FC<InsightsStatCardProps> = ({
  label,
  value,
  sub,
  icon: Icon,
  accent = 'text-primary-600 dark:text-primary-400',
  loading,
  info,
  className = '',
}) => (
  <div className={`${opsStatCard} ${className}`}>
    <div className="flex items-start justify-between gap-2">
      <div className="flex min-w-0 items-center gap-1.5">
        <p className="text-xs font-medium uppercase tracking-wide text-gray-400 dark:text-gray-500">
          {label}
        </p>
        {info && <MetricInfoPopover title={label} info={info} />}
      </div>
      {Icon && (
        <div className={`rounded-lg bg-gray-50 p-2 dark:bg-gray-900/80 ${accent}`}>
          <Icon className="h-4 w-4" />
        </div>
      )}
    </div>
    {loading ? (
      <div className="mt-2 h-8 w-24 animate-pulse rounded bg-gray-200 dark:bg-gray-700" />
    ) : (
      <p className="mt-2 text-2xl font-bold tabular-nums text-gray-900 dark:text-white">{value}</p>
    )}
    {sub && !loading && <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">{sub}</p>}
  </div>
);

export default InsightsStatCard;
